import { Injectable, InjectionToken } from '@angular/core';
import { PaginatedResponse } from '../../shared/pagination/paginated-response';
import { UpdateWorkplaceApiBody, WorkplaceApi } from '../api-types/workplace.api';
import { CreateWorkplace, UpdateWorkplaceBody, Workplace } from '../app-types/workplace.app';
import {
	transformApiInstitutionWorkplaceNeighborsToAppInstitutionWorkplaceNeighbors,
	transformApiWorkplacesToAppWorkplaces,
	transformApiWorkplaceToAppWorkplace,
	transformAppCreateWorkplaceToApiCreateWorkplace,
	transformAppUpdateWorkplaceBodyToApiUpdateWorkplaceBody,
} from '../transformers/workplace-transform';
import { BaseRequestService } from './base-request.service';
import { NeighborContext } from '../app-types/neighbors.app';
import { ApiNeighborContext } from '../api-types/neighbor.api';

export const WORKPLACE_SERVICE = new InjectionToken<WorkplaceService>('WORKPLACE_SERVICE');

@Injectable()
export class WorkplaceService extends BaseRequestService {
	public async getAllByInstitutionId(
		institutionId: number | string,
		offset?: number,
		range?: number,
	): Promise<PaginatedResponse<Workplace>> {
		const response = await this.get<PaginatedResponse<WorkplaceApi>>(`institution/branches`, {
			institutionId,
			offset,
			range,
		});
		const workplaces = transformApiWorkplacesToAppWorkplaces(response.entities);
		return {
			...response,
			entities: workplaces,
		};
	}

	public async create(req: CreateWorkplace, institutionId: number | string) {
		const body = transformAppCreateWorkplaceToApiCreateWorkplace(req);
		const response = await this.post(`institution/${institutionId}/branches`, body);
		return response;
	}

	public async getById(institutionId: number | string, branchId: number | string): Promise<Workplace> {
		const response = await this.get<WorkplaceApi>(`institution/${institutionId}/branches/${branchId}`);
		return transformApiWorkplaceToAppWorkplace(response);
	}

	public update = async (institutionId: number, branchId: number, body: UpdateWorkplaceBody) => {
		const apiBody = transformAppUpdateWorkplaceBodyToApiUpdateWorkplaceBody(body);
		const response = await this.put<UpdateWorkplaceApiBody, UpdateWorkplaceApiBody>(
			`institution/${institutionId}/branches/${branchId}`,
			apiBody,
		);
		return response;
	};

	public delete = async (institutionId: number, branchId: number) => {
		await this.remove<void>(`institution/${institutionId}/branches/${branchId}`);
	};

	public async getWorkplaceNeighbors(
		institutionId: number | string,
		branchId: number | string,
	): Promise<NeighborContext<Workplace>> {
		const response = await this.get<ApiNeighborContext<WorkplaceApi>>(
			`institution/${institutionId}/branches/${branchId}/neighbors`,
		);
		return transformApiInstitutionWorkplaceNeighborsToAppInstitutionWorkplaceNeighbors(response);
	}
}

@Injectable()
export class WorkplaceMockApi extends BaseRequestService {
	public constructor() {
		super();
		console.warn('|||||||||||||||||||| WORKPLACE_MOCK_SERVICE IS USED |||||||||||||||||||||||');
	}

	public async create(req: CreateWorkplace) {
		return {
			id: '1234',
			...req,
		};
	}
}
